import type { LocationDTO } from '../schemas';
import type { Location } from '../types';

/**
 * Maps a Location DTO to a domain Location model.
 */
export function mapLocationDTOToDomain(dto: LocationDTO): Location {
  const { details, ...location } = dto;

  return {
    ...(details as Record<string, string> || {}),
    ...location,
    id: dto.id || '',
    mapData: typeof location.mapData === 'string' ? location.mapData : undefined,
  };
}

/**
 * Maps a domain Location back to a DTO Location.
 */
export function mapDomainToDTO(domain: Partial<Location>): Partial<LocationDTO> {
  const rest = Object.fromEntries(
    Object.entries(domain).filter(([key]) => key !== 'mainImageUrl' && key !== 'mainImagePath')
  );

  return rest;
}
